import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "rounded-md border bg-card text-card-foreground shadow-lg",
        },
      }}
    />
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- pre-existing pattern; HMR-only concern
export { toast } from "sonner";
